import { useEffect, useState } from 'preact/hooks';
import { listKnowledgeContent, deleteKnowledgeContent } from '../lib/api';
import { activeToken } from '../store/global';
import type { KnowledgeContent } from '../types/agno-api';
import { PageHeader } from '../components/PageHeader';
import { DataTable } from '../components/DataTable';
import { formatRelative, truncate } from '../lib/format';

export function Knowledge() {
  const [items, setItems] = useState<KnowledgeContent[]>([]);

  const refresh = async () => {
    if (!activeToken.value) return;
    try {
      const res = await listKnowledgeContent();
      const data = Array.isArray(res) ? res : (res as { data: KnowledgeContent[] }).data || [];
      setItems(data);
    } catch (e) {
      console.error(e);
    }
  };

  useEffect(() => {
    refresh();
  }, [activeToken.value]);

  const remove = async (id: string) => {
    if (!confirm('Remover este conteúdo da base?')) return;
    await deleteKnowledgeContent(id);
    refresh();
  };

  return (
    <div class="mx-auto max-w-7xl px-6 py-6">
      <PageHeader
        title="Conhecimento"
        description="Base de conhecimento indexada (pgvector) que o agente consulta via RAG."
        icon={<i class="ph ph-book-open text-xl" />}
      />

      <DataTable
        rows={items as unknown as Array<Record<string, unknown>>}
        rowKey={(r) => (r as unknown as KnowledgeContent).id}
        columns={[
          {
            key: 'name',
            label: 'Nome',
            render: (r) => {
              const c = r as unknown as KnowledgeContent;
              return (
                <div>
                  <div class="font-medium">{c.name || c.id}</div>
                  {c.description && (
                    <div class="text-xs text-muted-foreground">{truncate(c.description, 80)}</div>
                  )}
                </div>
              );
            },
          },
          { key: 'type', label: 'Tipo', render: (r) => <span class="font-mono tabular-nums text-xs">{(r as unknown as KnowledgeContent).type || '—'}</span>, width: '12ch' },
          {
            key: 'status',
            label: 'Status',
            width: '12ch',
            render: (r) => {
              const status = (r as unknown as KnowledgeContent).status;
              return (
                <span class={`text-xs ${status === 'ready' ? 'text-success' : 'text-muted-foreground'}`}>{status || '—'}</span>
              );
            },
          },
          { key: 'created', label: 'Criado', render: (r) => <span class="text-xs">{formatRelative((r as unknown as KnowledgeContent).created_at)}</span>, width: '14ch' },
          {
            key: 'actions',
            label: '',
            width: '5ch',
            render: (r) => (
              <button
                class="inline-flex items-center justify-center size-8 rounded-md text-muted-foreground hover:bg-destructive/10 hover:text-destructive focus-visible:outline-none focus-visible:ring-[3px] focus-visible:ring-destructive/40"
                onClick={() => remove((r as unknown as KnowledgeContent).id)}
                title="Excluir conteúdo"
                aria-label="Excluir conteúdo"
              >
                <i class="ph ph-trash text-sm" />
              </button>
            ),
          },
        ]}
        empty={
          activeToken.value
            ? 'Nenhum conteúdo na base. Adicione uma URL ou faça upload para começar.'
            : 'Configure o token para ver a base.'
        }
      />
    </div>
  );
}
